import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import { 
    IsXsDownScreen
} from '../../../business-components/Service/GlobalService'

import {
    GridContainer,
    GridItem1,
    GridItem2,
    GridItem3xs6,
    GridItem4xs1,
    GridItem4xs12,
    GridItem5,
    GridItem5xs7,
    GridItem6,
    GridItem6xs10,
    GridItem7xs10,
    GridItem8xs12,
    GridItem10,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDividerElementos,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    TextFieldNumberSelectDestaque,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    TipoDiaDia,
    IconButtonClearEntradaDadosDiaDia,
    Valor,
    ValorNaAposentadoria,
    HelpValorNaAposentadoria,
    //ParentescoDependente,
    TipoPeriodicidadePagto,
    TipoFormaPagto,
    DespesaPessoal,
    HelpDespesaPessoal,
    ConsumirRecursosFinanceirosEmVezDaReceitaMensal,
    HelpConsumirRecursosFinanceirosEmVezDaReceitaMensal,
    RecursoFinanceiroConsumirRecursosFinanceirosEmVezDaReceitaMensal,
    PeriodoDiaDia,
    AlterarPeriodoDiaDia,
    MesAnoInicial,
    MesAnoFinal,
    DiaDiaIraOcorrerAteExpectativaVida,
    ValorAcumulado,
    ValorCompra,
    TitularRespValorCompra,
    DescricaoDiversasOutros,
    HelpDescricaoDiversasOutros,
    GrupoDespesa,
    DescricaoGrupoDespesaOutras,
    Observacao,
} from './DespesasCompDiaDia'



const DespesasFormDiaDiaItem = ({ values, handleChange, setFieldValue, arrayHelpers, linhaTipoLicenca, jsonConfiguracao, tipoDiaDiaSelecionado,
    item, ind, simplificado }) => {

    const isXsDownScreen = IsXsDownScreen()



    return (
        <CardGridEntradaDados>
            <CardGridDivHeaderEntradaDados>
                <GridContainer>
                    <GridItem7xs10>
                        <TipoDiaDia
                            TextFieldNumberSelectTipoDiaDia={
                                TextFieldNumberSelectDestaque
                            }
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem7xs10>

                    <GridItem4xs1 />

                    <GridItem1>
                        <IconButtonClearEntradaDadosDiaDia
                            values={values}
                            setFieldValue={setFieldValue}
                            item={item}
                            ind={ind}
                            arrayHelpers={arrayHelpers}
                            simplificado={simplificado}
                        />
                    </GridItem1>
                </GridContainer>
            </CardGridDivHeaderEntradaDados>

            <CardGridDivBodyEntradaDados
                style={{
                    display: 
                        item.tipoDiaDia
                            ? "block"
                            : "none"
                }} 
            >
                <GridContainer>
                    <GridItem5>
                        <Valor
                            values={values}
                            item={item}
                            ind={ind}
                            handleChange={handleChange} 
                        />
                    </GridItem5>
                    {!item.alterarPeriodoDiaDia &&
                    (
                        item.familiar === HARDCODE.idFamiliarCliente ||
                        item.familiar === HARDCODE.idFamiliarConjuge
                    ) && (
                        <>
                            <GridItem5>
                                <ValorNaAposentadoria
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                    //labelCurto={false}
                                />
                            </GridItem5>
                            <GridItem1>
                                <HelpValorNaAposentadoria/>
                            </GridItem1>
                        </>
                    )}
                    
                    {/*tipoDiaDiaSelecionado.pensaoDependente === "S" && (
                        <GridItem5>
                            <ParentescoDependente
                                item={item}
                                ind={ind}
                                handleChange={handleChange} 
                            />
                        </GridItem5>
                    )*/}
                </GridContainer>

                <GridContainer>
                    <GridItem5>
                        <TipoPeriodicidadePagto
                            values={values}
                            item={item}
                            ind={ind}
                            handleChange={handleChange} 
                        />
                    </GridItem5>
                    <GridItem5xs7>
                        <TipoFormaPagto
                            item={item}
                            ind={ind}
                            handleChange={handleChange} 
                            jsonConfiguracao={jsonConfiguracao}
                        />
                    </GridItem5xs7>
                </GridContainer>

                <GridContainer>
                    {!item.alterarPeriodoDiaDia && (
                        <GridItem8xs12
                            className={'mt-3 ' + (isXsDownScreen ? 'mb-2' : 'mb-4')}
                        >
                            <PeriodoDiaDia/>
                        </GridItem8xs12>
                    )}

                    {item.tipoPeriodicidadePagto !== HARDCODE.idTipoPeriodicidadeUnica && (
                        <GridItem4xs12>
                            <AlterarPeriodoDiaDia
                                values={values}
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem4xs12>
                    )}

                    {item.alterarPeriodoDiaDia && (
                        <>
                            <GridItem3xs6>
                                <MesAnoInicial
                                    values={values}
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange} 
                                />
                            </GridItem3xs6>
                            {!item.diaDiaIraOcorrerAteExpectativaVida &&
                            item.tipoPeriodicidadePagto !== HARDCODE.idTipoPeriodicidadeUnica && (
                                <GridItem3xs6>
                                    <MesAnoFinal
                                        values={values}
                                        item={item}
                                        ind={ind}
                                        handleChange={handleChange} 
                                    />
                                </GridItem3xs6>
                            )}
                            {item.tipoPeriodicidadePagto !== HARDCODE.idTipoPeriodicidadeUnica && (
                                <GridItem12>
                                    <DiaDiaIraOcorrerAteExpectativaVida
                                        item={item}
                                        ind={ind}
                                        handleChange={handleChange} 
                                    />
                                </GridItem12>
                            )}
                        </>
                    )}
                </GridContainer>

                <GridContainer>
                    <GridItem10>
                        <DescricaoDiversasOutros
                            item={item}
                            ind={ind}
                            handleChange={handleChange} 
                        />
                    </GridItem10>
                    <GridItem2>
                        <HelpDescricaoDiversasOutros/>
                    </GridItem2>
                </GridContainer>

                {tipoDiaDiaSelecionado.morte === "N" && tipoDiaDiaSelecionado.invalidez === "N" && (
                    <GridContainer>
                        <GridItem6>
                            <GrupoDespesa
                                item={item}
                                ind={ind}
                                handleChange={handleChange} 
                            />
                        </GridItem6>

                        {item.grupoDespesa === HARDCODE.idGrupoDespesaOutras && (
                            <GridItem6>
                                <DescricaoGrupoDespesaOutras
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange} 
                                />
                            </GridItem6>
                        )}
                    </GridContainer>
                )}

                <CardGridDividerElementos/>

                {(item.familiar === HARDCODE.idFamiliarCliente ||
                item.familiar === HARDCODE.idFamiliarConjuge) && (
                    <>
                        {tipoDiaDiaSelecionado.morte === "N" && tipoDiaDiaSelecionado.invalidez === "N" && (
                            <GridContainer>
                                <GridItem6xs10>
                                    <DespesaPessoal
                                        values={values}
                                        item={item}
                                        ind={ind}
                                        handleChange={handleChange}
                                        labelCurto={false}
                                    />
                                </GridItem6xs10>
                                <GridItem1>
                                    <HelpDespesaPessoal/>
                                </GridItem1>
                            </GridContainer>
                        )}

                        {linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === 'S' &&
                        tipoDiaDiaSelecionado.morte === "N" &&
                        tipoDiaDiaSelecionado.invalidez === "N" && (
                            <>
                                <GridContainer>
                                    <GridItem10>
                                        <ConsumirRecursosFinanceirosEmVezDaReceitaMensal
                                            item={item}
                                            ind={ind}
                                            handleChange={handleChange} 
                                        />
                                    </GridItem10>
                                    <GridItem1>
                                        <HelpConsumirRecursosFinanceirosEmVezDaReceitaMensal/>
                                    </GridItem1>
                                </GridContainer>

                                {item.consumirRecursosFinanceirosEmVezDaReceitaMensal && item.alterarPeriodoDiaDia && (
                                    <GridContainer>
                                        <GridItem10>
                                            <RecursoFinanceiroConsumirRecursosFinanceirosEmVezDaReceitaMensal
                                                values={values}
                                                item={item}
                                                ind={ind}
                                                handleChange={handleChange} 
                                            />
                                        </GridItem10>
                                    </GridContainer>
                                )}
                            </>
                        )}
                    </>
                )}
                
                {tipoDiaDiaSelecionado.informaValorCompra === "S" && item.alterarPeriodoDiaDia &&
                item.valorAcumulado && item.valorAcumulado !== 0 && (
                    <GridContainer>
                        <GridItem6>
                            <ValorAcumulado
                                item={item}
                                ind={ind}
                                handleChange={handleChange} 
                            />
                        </GridItem6>
                        <GridItem6>
                                <ValorCompra
                                item={item}
                                ind={ind}
                                handleChange={handleChange} 
                            />
                        </GridItem6>
                        {item.valorCompra && (
                            <GridItem6>
                                <TitularRespValorCompra
                                    values={values}
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange} 
                                />
                            </GridItem6>
                        )}
                    </GridContainer>
                )}

                <CardGridDividerElementos/>

                <GridContainer>
                    <GridItem12>
                        <Observacao
                            item={item}
                            ind={ind}
                            handleChange={handleChange} 
                        />
                    </GridItem12>
                </GridContainer>
            </CardGridDivBodyEntradaDados>
        </CardGridEntradaDados>
    )
}

export default DespesasFormDiaDiaItem